// Logo SELFCNTRL : deux disques qui se chevauchent — le matin (bleu) et la
// nuit (bleu nuit). Leur intersection, en blanc, est le moment où le toi du
// matin décide pour le toi de la nuit. Piste n° 6 d'une planche générée sur
// ChatGPT (9 oct. 2026), redessinée en SVG. Même dessin que public/favicon.svg.

export function UMark ({ className }) {
  return (
    <svg className={className} viewBox="0 0 48 32" fill="none" aria-hidden="true">
      <defs>
        <clipPath id="sc-mark-l"><circle cx="16" cy="16" r="15" /></clipPath>
      </defs>
      <circle cx="16" cy="16" r="15" fill="#2563EB" />
      <circle cx="32" cy="16" r="15" fill="#0B1326" />
      <circle cx="32" cy="16" r="15" fill="#fff" clipPath="url(#sc-mark-l)" />
    </svg>
  )
}

export function UBrand () {
  return (
    <span className="u-brand">
      <UMark className="u-brand__mark" />
      <span className="u-brand__word">selfcntrl</span>
    </span>
  )
}
